import ExcelJS from 'exceljs';
import { loadFileAsArrayBuffer } from "./files";

export const xlsxMimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const xlsMimeType = "application/vnd.ms-excel";
export const excelMimeTypes = [xlsxMimeType, xlsMimeType];

export async function parseExcel(file) {
	try {
		let spreadsheetData = await loadSpreadsheetDataFromFile(file);
		let results = await loadWorkbookFromFileDataExcelJS(spreadsheetData);
		return results;
	} catch (err) {
		console.error(err);
		return err;
	}
}

async function loadSpreadsheetDataFromFile(file) {
	const data = await loadFileAsArrayBuffer(file);
	return data;
}

async function loadWorkbookFromFileDataExcelJS(data) {
	const workbook = new ExcelJS.Workbook();
	let results = {};
	await workbook.xlsx.load(data).then(workbook => {
		workbook.eachSheet((sheet, id) => {
			let headers;
			let rowArray = [];
			sheet.eachRow((row, rowIndex) => {
				if (headers == null && row.values != null) {
					headers = row.values;
				} else {
					let rowObj = {};
					row.eachCell((cell, cellIndex) => {
						const header = headers[cellIndex];
						let value;
						if (cell.type === ExcelJS.ValueType.Formula) {
							value = row.getCell(cellIndex).result ?? '';
						} else {
							value = cell.value;
						}
						if (cell.type === ExcelJS.ValueType.Date || cell.effectiveType === ExcelJS.ValueType.Date) {
							const utcDate = new Date(value.getTime() + (value.getTimezoneOffset() * 60000))
							value = utcDate;
						}
						rowObj[header] = value;
					});
					rowArray.push(rowObj)
				}	
			});
			results[sheet.name] = rowArray
		});
	});
	return results;
}